import Usporadatel from "../Usporadatel/Usporadatel";
import { useSearchParams } from "react-router-dom";

export default function Notifications({ active, onUnreadCount }) {
  const [search] = useSearchParams();
  return <Usporadatel topicsOnly active={active} onUnreadCount={onUnreadCount} initialTopicId={search.get("topic")} />;
}